<template>
  <card class="flex-wrap" customClass="card-vault-edit">
    <template #header>
      <div class="header-vault-edit justify-content-between flex-wrap">
        <div class="card-title">
          {{ data.header }}
        </div>
        <div class="d-flex align-items-center">
          <button
            v-if="!editable"
            class="btn btn-primary btn-vault-save edit"
            type="button"
            @click="editable = !editable"
          >
            edit
          </button>
          <button
            v-else
            class="btn btn-primary btn-vault-save"
            type="button"
            @click="save"
            :disabled="loading"
          >
            Save
          </button>
        </div>
      </div>
    </template>
    <div class="w-100">
      <div class="box-fixed-text" v-if="!editable">
        {{ data.textEdit }}
      </div>
      <b-form-textarea
        id="textarea-box"
        v-model="data.textEdit"
        v-else
        rows="4"
      >
      </b-form-textarea>
    </div>
  </card>
</template>

<script>
import Card from "../Card.vue";

export default {
  name: "Vault-Text-Edit",
  data() {
    return {
      editable: false,
      loading: false,
    };
  },
  components: {
    Card,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  methods: {
    save() {
      this.loading = true;
      this.$store
        .dispatch("API", {
          url: `/api/${this.data.api}`,
          method: "POST",
          id: this.$route.params.id,
          [this.data.header.toLowerCase()]: this.data.textEdit,
        })
        .then((result) => {
          this.editable = !this.editable;
        })
        .catch((err) => {})
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss">
@import "./resources/sass/app.scss";

.card-vault-edit {
  border: 1px solid #eaedf0 !important;
  border-radius: 4px !important;
  background: $primary-4;
  .header-vault-edit {
    border-bottom: 1px solid #eaedf0;
    padding-bottom: 13px;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
  }
  .card-title {
    font-style: normal;
    font-weight: 900;
    font-size: 20px;
    line-height: 27px;
    //letter-spacing: 0.04em;
    text-transform: uppercase;
    color: $primary-5;
    margin: auto 0;
  }
  .btn-vault-save {
    width: 136px;
    height: 34px;
    border-radius: 4px !important;
    font-family: Exo !important;
    font-weight: bold !important;
    font-size: 12px !important;
    line-height: 16px !important;
    text-transform: uppercase;
    background: #27ae60 !important;
    &.edit {
      color: #27ae60 !important;
      background: $primary-4 !important;
      border: 1px solid #27ae60 !important;
    }
  }
  .box-fixed-text {
    padding: 10px;
    min-height: 76px;
    font-family: Exo;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: $primary-5;
  }
  .form-control,
  .form-control:active,
  .form-control:focus,
  .form-control:disabled {
    display: block;
    width: 100%;
    min-height: 76px; //max-content;
    padding: 10px;
    font-family: Exo;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: $primary-5;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #b9b9b9;
    border-radius: 4px;
    box-sizing: border-box;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
}

@media screen and (min-width: 0px) and (max-width: 768px) {
}
</style>
